
import Vue from "vue";
import { IDataTableColumn } from "winfakt-vue-components/src/classes";
import { toDateString } from "@/utils/strings";
import { IPaginationData } from "@/utils/browse/pagination-data";
import { ReferralService, IReferral, IReferralInvite, ReferralRewardedFilter, InviteStatusFilter } from "@/services/referral-service";

export default Vue.extend({
	data(){
		return {
			ready: false,
			tab: 0,
			referrals: [] as IReferral[],
			invites: [] as IReferralInvite[],
			orderColumn: "this.DateCreated",
			orderDirection: false,
			rewardedFilter: "all" as ReferralRewardedFilter,
			inviteStatusFilter: "all" as InviteStatusFilter,
			total: 0,
			limit: 20,
			page: 1,
			currentQueryId: 0.0,
			selected: null as IReferral | null,
			rewarded: false,
			note: "",
			saving: false
		};
	},
	computed: {
		// eslint-disable-next-line max-lines-per-function
		columns():IDataTableColumn[]{
			return [
				{
					name: "ID",
					property: "id",
					orderColumnName: "this.ID",
					width: "70px"
				},
				{
					name: "Aanbrenger",
					property: "referrerCompanyName",
					disableSorting: true,
					print(value:string, item:IReferral):string{
						return value || ("#" + item.referrerCompanyId);
					}
				},
				{
					name: "Aangebracht account",
					property: "referredCompanyName",
					disableSorting: true,
					print(value:string, item:IReferral):string{
						return value || ("#" + item.referredCompanyId);
					}
				},
				{
					name: "Datum",
					property: "dateCreated",
					orderColumnName: "this.DateCreated",
					width: "120px",
					print(value:string):string{
						return value ? toDateString(new Date(value)) : "";
					}
				},
				{
					name: "Beloond",
					property: "rewarded",
					orderColumnName: "this.Rewarded",
					width: "100px",
					print(value:boolean):string{
						return value ? "Ja" : "Nee";
					}
				}
			];
		},
		tabs():string[]{
			return ["Referrals", "Uitnodigingen"];
		},
		// eslint-disable-next-line max-lines-per-function
		inviteColumns():IDataTableColumn[]{
			return [
				{
					name: "ID",
					property: "id",
					orderColumnName: "this.ID",
					width: "70px"
				},
				{
					name: "Aanbrenger",
					property: "referrerCompanyName",
					disableSorting: true,
					print(value:string, item:IReferralInvite):string{
						return value || ("#" + item.referrerCompanyId);
					}
				},
				{
					name: "E-mail",
					property: "email",
					orderColumnName: "this.Email"
				},
				{
					name: "Verzonden",
					property: "dateSent",
					orderColumnName: "this.DateSent",
					width: "120px",
					print(value:string):string{
						return value ? toDateString(new Date(value)) : "";
					}
				},
				{
					name: "Status",
					property: "status",
					orderColumnName: "this.Status",
					width: "130px",
					print(value:string):string{
						return value == "registered" ? "Geregistreerd" : "Verzonden";
					}
				}
			];
		},
		pageCount():number {
			return this.total / this.limit;
		},
		showTotalRecordsText():string {
			if (this.total != 1) {
				return this.total + " records gevonden";
			}
			return this.total + " record gevonden";
		},
		limits():any[] {
			let limits = [10, 20, 25, 50, 100, 200, 250, 500];
			return limits.map(l => ({text: "Limit " + l + " records", value: l}));
		},
		filterItems():any[] {
			return [
				{text: "Alle", value: "all"},
				{text: "Beloond", value: "rewarded"},
				{text: "Niet beloond", value: "unrewarded"}
			];
		},
		inviteFilterItems():any[] {
			return [
				{text: "Alle", value: "all"},
				{text: "Verzonden", value: "sent"},
				{text: "Geregistreerd", value: "registered"}
			];
		},
	},
	watch: {
		limit() {
			if (this.pageCount > this.page){
				this.page = this.pageCount;
			}
			this.load();
		},
		page() {
			this.load();
		},
		orderColumn() {
			this.load();
		},
		orderDirection() {
			this.load();
		},
		rewardedFilter() {
			this.page = 1;
			this.load();
		},
		inviteStatusFilter() {
			this.page = 1;
			this.load();
		},
	},
	methods: {
		formatDate(value:string|null):string{
			return value ? toDateString(new Date(value)) : "";
		},
		async load(){
			if (this.tab == 0){
				await this.getReferrals();
			}else{
				await this.getInvites();
			}
		},
		paginationData():IPaginationData{
			return {
				limit: this.limit,
				offset: Math.floor((this.page - 1) * this.limit),
				order: this.orderColumn,
				ascending: this.orderDirection
			};
		},
		async getReferrals(){
			if (!this.ready) return;
			let id = Math.random();
			this.currentQueryId = id;
			let response = await ReferralService.getAllReferrals(this.paginationData(), this.rewardedFilter);
			if (this.currentQueryId != id) return;
			this.referrals = response.data;
			this.total = response.records;
			if (this.page != 1 && this.referrals.length == 0){
				this.page = 1;
				await this.getReferrals();
			}
		},
		async getInvites(){
			if (!this.ready) return;
			let id = Math.random();
			this.currentQueryId = id;
			let response = await ReferralService.getAllInvites(this.paginationData(), this.inviteStatusFilter);
			if (this.currentQueryId != id) return;
			this.invites = response.data;
			this.total = response.records;
			if (this.page != 1 && this.invites.length == 0){
				this.page = 1;
				await this.getInvites();
			}
		},
		setTab(value:number){
			if (this.tab == value) return;
			this.tab = value;
			this.page = 1;
			this.orderColumn = value == 0 ? "this.DateCreated" : "this.DateSent";
			this.orderDirection = false;
			this.load();
		},
		onItemClicked(item:IReferral|IReferralInvite){
			if (this.tab == 0){
				this.openReward(item as IReferral);
			}else{
				this.goToCompany((item as IReferralInvite).referrerCompanyId);
			}
		},
		onOrder(event:{order:string, ascending:boolean}){
			this.orderColumn = event.order;
			this.orderDirection = event.ascending;
		},
		setPage(value:number){
			this.page = Math.round(value);
		},
		goToCompany(companyId:number){
			if (!companyId) return;
			this.$router.push(`/companies/${companyId}/info`);
		},
		openReward(referral:IReferral){
			this.selected = referral;
			this.rewarded = referral.rewarded;
			this.note = referral.rewardNote || "";
		},
		async saveReward(){
			if (!this.selected) return;
			this.saving = true;
			try{
				let updated = await ReferralService.setRewarded(this.selected.id, this.rewarded, this.note);
				let index = this.referrals.findIndex(r => r.id == updated.id);
				if (index >= 0){
					this.$set(this.referrals, index, updated);
				}
				this.selected = null;
				this.$wf.notify("Referral bijgewerkt.", "success", 3000, "check");
			}catch(err){
				this.$wf.notify("Kon referral niet bijwerken.", "error", 4000, "exclamation-triangle");
			}finally{
				this.saving = false;
			}
		},
	},
	created(){
		this.ready = true;
		this.getReferrals();
	}
});
